import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ColumnFieldTitle, OfbizField, OfbizList, RemoteFormData } from '@urbannex/ofbiz-forms';
import { getColumnFieldTitles, getFields } from '@urbannex/view-containers';
import { PART_FORMS } from '../../../../forms';

@Component({
  selector: 'pty-customer-postal',
  templateUrl: './cutomer-postal.component.html',
  styleUrls: ['./cutomer-postal.component.scss']
})
export class CutomerPostalComponent implements OnChanges{
  @Input() partyId:string;
  listForm:OfbizList;
  

  title:"PostalAddresses";
  fieldOptions:any;
  state$:any;
  isLookup:false;
  cardMode:true;
  remoteFormData:RemoteFormData;
  columnFieldTitles:ColumnFieldTitle[];
  columnFields:OfbizField[];
  listOptions:any;
  hasRemoteData = false;
  
  constructor(){}
  ngOnChanges(changes: SimpleChanges): void {
    if(changes["partyId"]){
      this.listForm = new OfbizList({
        listFormName:"CustomerPostalAddress",
        listFormLocation: "component://kwikstore/widget/PartyForms.xml",
        columnFields: getFields("CustomerPostalAddress", PART_FORMS),
        columnFieldTitles:getColumnFieldTitles("CustomerPostalAddress",PART_FORMS),
        //fieldFormFields:any,
        listType:"grid",
        emptyListMessage:"No Postal Addresses found for this customer",
        remoteFormData:{
          formData:{
            formName:"CustomerPostalAddress",
            formLocation:"component://kwikstore/widget/PartyForms.xml",
            viewIndex:0,
            listType:"grid",
          },
          parameters:{"partyId":this.partyId},
          endPoint:"partymgr"
        }
      })
      //this.listForm.remoteFormData.parameters["partyId"] = this.partyId;
      //let remoteData = this.listForm.remoteFormData;
      
      this.remoteFormData = {
        formData:{
          formName:"CustomerPostalAddress",
          formLocation:"component://kwikstore/widget/PartyForms.xml",
          viewIndex:0,
          listType:"grid",
        },
        parameters:{"partyId":this.partyId},
        endPoint:"partymgr"
      };
      this.columnFields = getFields("CustomerPostalAddress",PART_FORMS),
      this.columnFieldTitles = getColumnFieldTitles("CustomerPostalAddress",PART_FORMS),
      this.state$.remoteFormData = this.remoteFormData;
      this.hasRemoteData = true;
      console.log(this.remoteFormData);
    }
  }

  handleHyperLinkSelected(e){

  }

  handleListSucessNotify(e){

  }

  showOverview(e){

  }

  showEditDialog(e){

  }
}
